import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
  regex,
  TopToolbar,
  ListButton,
} from 'react-admin';
import { validateUUID } from '../../utils/validation';
import { TemplateSelectInput } from './TemplateFields';

const CreateActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

const validateSlug = [
  required(),
  regex(/^[a-z0-9-]+$/, 'Must be lowercase alphanumeric with hyphens'),
];

export const ClientCreate = () => (
  <Create redirect="show" actions={<CreateActions />}>
    <SimpleForm defaultValues={{ status: 'pending' }}>
      <TextInput source="name" validate={required()} fullWidth />
      <TextInput
        source="slug"
        validate={validateSlug}
        helperText="Lowercase alphanumeric with hyphens (e.g., my-client)"
        fullWidth
      />
      <TextInput
        source="zenkyStoreId"
        label="Zenky Store ID"
        validate={validateUUID}
        helperText="UUID format (e.g., 550e8400-e29b-41d4-a716-446655440000)"
        fullWidth
        required
      />
      <TemplateSelectInput />
      <SelectInput
        source="status"
        choices={[
          { id: 'pending', name: 'Pending' },
          { id: 'active', name: 'Active' },
          { id: 'inactive', name: 'Inactive' },
        ]}
        defaultValue="pending"
      />
    </SimpleForm>
  </Create>
);
